import { jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
const ScrollIntoView = (props)=>{
    const myRef = useRef(null);
    useEffect(()=>{
        if (!!myRef && !!myRef.current) {
            const refDOM = myRef.current;
            if (refDOM?.scrollIntoView) refDOM?.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest'
            });
        }
    }, []);
    return /*#__PURE__*/ jsx("div", {
        ref: myRef,
        style: {
            ...props.style
        },
        children: props.children
    });
};
export { ScrollIntoView };
